<template>
    <div id="partner_main" class="ui centered container">
        <div class="ui segment">
            <div class="ui text menu">
                <div class="menu">
                    <div class="item">
                        <div class="ui form">
                            <select class="ui simple dropdown" v-model="filterType" @change="updatePartners">
                                <option :value="'계약중'">계약중</option>
                                <option :value="'계약종료'">계약종료</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="right menu">
                    <div class="item">
                        <div class="ui orange small button" @click="openCalculate">정산</div>
                    </div>
                    <div class="item">
                        <div class="ui primary small button" @click="openPartnerAdd">업체 등록</div>
                    </div>
                </div>
            </div>
            <table class="ui selectable very basic table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>아이디</th>
                        <th>업체명</th>
                        <th>전화번호</th>
                        <th>설명</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(partner, index) in filteredPartners" :key="partner._id">
                        <td class="collapsing">{{ index+1 }}</td>
                        <td>{{ partner.id }}</td>
                        <td>{{ partner.name }}</td>
                        <td>{{ partner.phone }}</td>
                        <td>{{ partner.description }}</td>
                        <td class="right collapsing">
                            <div class="ui small basic icon buttons">
                                <button class="ui button" @click="openPartnerEdit(partner)">
                                    <i class="edit icon"></i>
                                </button>
                                <!-- <button class="ui button" @click="removePartner(partner)">
                                    <i class="trash icon"></i>
                                </button> -->
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th class="center aligned" colspan="10">
                            <div class="ui pagination menu">
                                <a class="icon item"><i class="left chevron icon"></i></a>
                                <a class="item" v-for="n in pageCount" :key="n">{{ n }}</a>
                                <a class="icon item"><i class="right chevron icon"></i></a>
                            </div>
                        </th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            filterType: 0,
            filteredPartners: 0,
        };
    },
    mounted: function()
    {
        this.filterType = "계약중";
        this.filteredPartners = this.getFilteredPartners();
        this.$nextTick(() => this.$event.call("closeLoading"));
    },
    methods:
    {
        openPartnerAdd() 
        {
            this.$event.call("openPartnerModal", null, this.updatePartners);
        },
        openPartnerEdit(partner)
        {
            this.$event.call("openPartnerModal", partner, this.updatePartners);
        },
        openCalculate()
        {
            this.$event.call("partnerCalculate_open");
        },
        removePartner(partner)
        {
            this.$api.removePartner(partner._id, (resData) => {
                this.partners = resData.partners;
            });
        },
        getFilteredPartners()
        {
            const array = [];
            switch (this.filterType) {
                default: for (const partner of this.partners) array.push(partner); break;
                case '계약중': for (const partner of this.partners) if (!partner.isTerminated) array.push(partner); break;
                case '계약종료': for (const partner of this.partners) if (partner.isTerminated) array.push(partner); break;
            }
            return array;
        },
        updatePartners()
        {
            this.filteredPartners = this.getFilteredPartners();
            this.$forceUpdate();
        },
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        pageCount: function() { return this.partners.length / 10 + (this.partners.length % 10 > 0) ? 1 : 0; },
        partners: {
            get: function() { return this.$store.getters.partners; },
            set: function(val) { return this.$store.commit("setPartners", val); },
        },
        products: {
            get: function() { return this.$store.getters.products; },
            set: function(val) { this.$store.commit("setProducts", val); },
        },
    },
}
</script>

<style>
#partner_main {
    margin-top:15px;
}
#partner_main .segment {
    min-width:800px;
    min-height: 800px;
}
#partner_main .ui.text.menu {
    margin: 0;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/PartnerMain.vue